// One decision per Turbo page view, per intro key: had this intro already
// played before the current visit? The first visit reads false and marks it
// played immediately, so every later visit renders settled. The answer is
// cached per page view so every element sharing a key agrees (otherwise the
// first caller would flip the flag and starve the rest).
const playedByKey = new Map()
document.addEventListener("turbo:visit", () => { playedByKey.clear() })

export function introAlreadyPlayed(key) {
  if (!playedByKey.has(key)) {
    const storageKey = `floosyo:${key}-intro-played`
    try {
      const played = localStorage.getItem(storageKey) === "1"
      if (!played) localStorage.setItem(storageKey, "1")
      playedByKey.set(key, played)
    } catch (_) {
      playedByKey.set(key, false)
    }
  }
  return playedByKey.get(key)
}

export function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}
